export default "__VITE_PUBLIC_ASSET__addaac31__"